import ElFooter from './Footer'

/* istanbul ignore next */
ElFooter.install = function (app) {
  app.component(ElFooter.name, ElFooter)
}

export { ElFooter }

export default ElFooter
